import { Requirement } from "../../types/requirement.response";
import { AddableCourse, CourseLite, CourseOption } from "../../types/course.response";
import { ProgramSummaryResponse } from "../../types/program.response";
import { CourseRequirementOverride } from "../../services/api/user-courses.api";
import ReqSectionHeader from "./ReqSectionHeader";
import RequirementBody from "./RequirementBody";
import { isRequirementFulfilled } from "../../utils/requirementResponseUtils";

interface RequirementSectionProps {
    program: ProgramSummaryResponse;
    requirement: Requirement;
    handleAddCourse: (newCourse: AddableCourse, overrides: CourseRequirementOverride[], semester: string | null, classSectionIds?: number[]) => void;
    handleDeleteCourse: (deletedCourse: CourseLite) => void;
    handleFavoriteCourse: (courseOption: CourseLite) => void;
    handleOverride: (course: CourseLite, override: CourseRequirementOverride) => void | Promise<void>;
    optimisticFavorites: Map<string, boolean>;
    fromHome?: boolean;
    userCourses?: CourseOption[];
    onRequirementClick?: (programId: string, requirementId: string) => void;
}

export default function RequirementSection({ program, requirement, handleAddCourse, handleDeleteCourse, handleFavoriteCourse, handleOverride, optimisticFavorites, fromHome, userCourses, onRequirementClick }: RequirementSectionProps) {

    const isFulfilled = isRequirementFulfilled(requirement);

    return (
        <div className="transition-all pb-12 md:pb-16">
            <ReqSectionHeader program={program} requirement={requirement} handleAddCourse={handleAddCourse} handleDeleteCourse={handleDeleteCourse} handleOverride={handleOverride} fromHome={fromHome} onRequirementClick={onRequirementClick} />
            {!isFulfilled && (
                <RequirementBody
                    programInfo={program.info}
                    requirement={requirement}
                    coursesMap={program.courses}
                    handleAddCourse={handleAddCourse}
                    handleDeleteCourse={handleDeleteCourse}
                    handleFavoriteCourse={handleFavoriteCourse}
                    handleOverride={handleOverride}
                    optimisticFavorites={optimisticFavorites}
                    userCourses={userCourses}
                    onRequirementClick={onRequirementClick}
                />
            )}
        </div>
    );
}
